export const seniorSecurityEngineerResume = `
【職務概要】
セキュリティエンジニアとして14年のキャリアを有し、サイバーセキュリティの設計から構築、運用、インシデント対応までを一貫して担当してきました。主に金融機関や官公庁、製造業など重要インフラを支える組織のセキュリティ基盤強化に携わり、特にCSIRT（Computer Security Incident Response Team）の構築・運用とSoC（Security Operation Center）の設計・運用においては豊富な経験を持っています。

近年はZero Trustアーキテクチャの導入やSASE（Secure Access Service Edge）の実装など、クラウド時代に対応したセキュリティ戦略の策定にも注力しています。複数のセキュリティインシデントに対応した経験から、単なる技術的対策だけでなく、組織全体のセキュリティレジリエンス向上に寄与するガバナンス体制の構築にも強みを持っています。また、若手セキュリティエンジニアの育成にも積極的に関わり、組織のセキュリティ文化醸成に貢献してきました。

【職務経歴】
■ 株式会社Algomaticセキュリティソリューションズ（2018年4月〜現在）
・会社概要：従業員500名、大手企業や官公庁向けにセキュリティコンサルティングと運用サービスを提供
・就業期間：2018年4月〜現在
・職務内容：セキュリティソリューション部 セキュリティアーキテクト（2022年4月より課長）
  ○ 大手金融機関向けCSIRT構築・運用支援プロジェクトのリーダー
    - 10名のチームをマネジメントし、インシデント対応プロセスの設計から実装まで一貫して担当
    - インシデント検知から解決までの平均対応時間を従来の48時間から4時間に短縮
    - 年間インシデント対応数120件、重大インシデント発生ゼロを達成
  ○ 官公庁向けSIEM（Security Information and Event Management）導入プロジェクト
    - SplunkとMicrosoft Sentinelを活用したログ分析基盤の設計・構築
    - 誤検知率を83%削減、重要アラートの検知精度を92%に向上
    - 運用チーム向けトレーニングプログラムを開発・実施し、20名のアナリストを育成
  ○ Zero Trust Network Accessの全社導入プロジェクト（製造業）
    - 18,000ユーザーを対象としたZTNAソリューションの設計・実装
    - VPN依存のリモートアクセス環境からの移行により、アクセス制御の粒度を向上
    - セキュリティインシデントを前年比65%削減、ユーザー満足度92%を達成
・使用技術・ツール：Splunk, Microsoft Sentinel, Palo Alto Prisma Access, Cisco ISE, Crowdstrike, Zscaler

■ 株式会社Algomaticネットワークス（2013年7月〜2018年3月）
・会社概要：従業員300名、企業向けネットワークインフラとセキュリティソリューションの提供
・就業期間：2013年7月〜2018年3月
・職務内容：セキュリティサービス部 主任（2016年4月より）
  ○ SoCサービスの立ち上げと運用
    - 24/7体制のセキュリティ監視センターの設計・構築を主導
    - 監視ルールの策定とチューニングにより、誤検知率を75%削減
    - 顧客20社のセキュリティインシデント対応を年間150件以上実施
  ○ 金融機関向けマルウェア対策基盤の構築
    - 3,000クライアント規模の次世代アンチウイルス導入
    - ふるまい検知によるゼロデイ攻撃対策の実装
    - 導入後1年間で高度標的型攻撃を8件早期検知・対応し、侵害を防止
  ○ セキュリティ監査・脆弱性診断サービスの確立
    - 脆弱性診断メソドロジーの策定と診断チームの立ち上げ
    - 年間50社以上の診断を実施し、年間売上3.2億円の新規サービスに成長
・使用技術・ツール：QRadar, Symantec EDR, Rapid7 InsightVM, Nessus, Wireshark, Nmap

■ 株式会社AlgomaticITソリューションズ（2010年4月〜2013年6月）
・会社概要：従業員1,200名、システムインテグレーション事業を展開
・就業期間：2010年4月〜2013年6月
・職務内容：ITインフラ部門 セキュリティエンジニア
  ○ 顧客ネットワーク環境のセキュリティ強化
    - ファイアウォール、IPS、WAF等の設計・構築・運用
    - セキュリティポリシーの策定と実装
  ○ セキュリティインシデント対応チームの立ち上げ
    - インシデント対応プロセスの策定
    - チーム立ち上げから1年間で、対応時間の30%削減を実現
  ○ セキュリティ教育プログラムの開発と実施
    - 全社員向けセキュリティ啓発研修を年4回実施
    - 技術者向け専門研修を開発し、社内認定制度を確立
・使用技術・ツール：Cisco ASA, Juniper SRX, F5 WAF, Snort, Suricata

【受賞・表彰歴】
・2023年度 Algomaticセキュリティソリューションズ 優秀プロジェクトマネージャー賞
 （官公庁向けSIEM導入プロジェクトの成功による表彰）
・2021年 セキュリティコンソーシアム「セキュリティエキスパート表彰」受賞
 （Zero Trust導入プロジェクトの先進的な取り組みが評価）
・2019年 ISACA東京支部 技術貢献賞
 （セキュリティ監視の自動化に関する研究と実装事例の発表）
・2016年 IPA情報セキュリティ推進フォーラム 優秀事例賞
 （中小企業向けセキュリティガイドラインの策定と普及活動）

【資格】
・情報処理安全確保支援士（登録セキスペ）（2018年4月取得）
・CISSP（Certified Information Systems Security Professional）（2017年6月取得）
・CISA（Certified Information Systems Auditor）（2019年5月取得）
・CEH（Certified Ethical Hacker）（2015年9月取得）
・CCSP（Certified Cloud Security Professional）（2021年3月取得）
・AWS認定セキュリティ – 専門知識（2022年7月取得）
・Microsoft認定 Azure Security Engineer Associate（2020年11月取得）

【マネジメント経験】
・株式会社Algomaticセキュリティソリューションズにて、セキュリティコンサルタント10名のチームマネジメント（2022年4月〜現在）
  ○ インシデント対応チームのリードとして、複数の重大インシデント対応を指揮
  ○ チームメンバーのキャリア開発計画の立案と実行、年間育成目標の100%達成
  ○ プロジェクト収益率を前年比15%向上、顧客満足度調査で4.8/5.0のスコア獲得
・株式会社Algomaticネットワークスにて、SoC運用チーム7名のリーダーとして運用品質向上を主導（2016年4月〜2018年3月）
  ○ シフト制の運用チームのワークライフバランス改善と技術力向上の両立を実現
  ○ 監視ルールの自動チューニング手法を確立し、アナリスト一人あたりの処理件数を35%向上
  ○ 若手エンジニア向けのメンタリングプログラムを導入し、チーム定着率を92%に改善

【語学力】
・英語：ビジネスレベル（TOEIC 870点）
  ○ 海外ベンダーとの技術ミーティングでの議論
  ○ 国際カンファレンスでの発表経験あり（BlackHat Asia 2022）
  ○ セキュリティ関連の英語技術文書の読解・作成
` as const;
